module.exports = __webpack_public_path__ + "static/media/Trivia.91e175c8.png";